// NodeActionDialog.jsx
import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Divider from '@mui/material/Divider';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import CircularProgress from '@mui/material/CircularProgress';
import { Alert, AlertTitle } from '@material-ui/core';
import Chip from '@mui/material/Chip';

import Grid from '@mui/material/Grid';
import WarningIcon from '@mui/icons-material/Warning';
import { Modal } from 'antd';
import { updateGeoLocationNameService, deleteGeoLocationService, addGeoLocationService } from '../../../services/geo-service';
import { useDispatch } from 'react-redux';
import { SNACKBAR_OPEN } from 'store/actions';
import useAuth from 'hooks/useAuth';

const LEVELS_DROPDOWN = [
    {
        level_id: 1,
        level_suffix_map: [
            {
                name_suffix: 'प्रांत',
                children_levels: [
                    {
                        name_suffix: 'विभाग',
                        level_id: 2
                    },
                    {
                        name_suffix: 'महानगर',
                        level_id: 2
                    }
                ]
            }
        ]
    },
    {
        level_id: 2,
        level_suffix_map: [
            {
                name_suffix: 'विभाग',
                children_levels: [
                    {
                        name_suffix: 'ग्रामीण जिल्हा',
                        level_id: 3
                    },
                    {
                        name_suffix: 'शहरी जिल्हा',
                        level_id: 3
                    }
                ]
            },
            {
                name_suffix: 'महानगर',
                children_levels: [
                    {
                        name_suffix: 'भाग',
                        level_id: 3
                    }
                ]
            }
        ]
    },
    {
        level_id: 3,
        level_suffix_map: [
            {
                name_suffix: 'ग्रामीण जिल्हा',
                children_levels: [
                    {
                        name_suffix: 'तालुका',
                        level_id: 6
                    },
                    {
                        name_suffix: 'मनपा शहर',
                        level_id: 4
                    }
                ]
            },
            {
                name_suffix: 'शहरी जिल्हा',
                children_levels: [
                    {
                        name_suffix: 'गट',
                        level_id: 5
                    }
                ]
            },
            {
                name_suffix: 'भाग',
                children_levels: [
                    {
                        name_suffix: 'शहरी नगर',
                        level_id: 7
                    }
                ]
            }
        ]
    },
    {
        level_id: 4,
        level_suffix_map: [
            {
                name_suffix: 'मनपा शहर',
                children_levels: [
                    {
                        name_suffix: 'शहरी नगर',
                        level_id: 7
                    }
                ]
            }
        ]
    },
    {
        level_id: 5,
        level_suffix_map: [
            {
                name_suffix: 'गट',
                children_levels: [
                    {
                        name_suffix: 'शहरी नगर',
                        level_id: 7
                    }
                ]
            }
        ]
    },
    {
        level_id: 6,
        level_suffix_map: [
            {
                name_suffix: 'तालुका',
                children_levels: [
                    {
                        name_suffix: 'उपखंड',
                        level_id: 8
                    },
                    {
                        name_suffix: 'उपखंड नगर',
                        level_id: 8
                    }
                ]
            }
        ]
    },
    {
        level_id: 7,
        level_suffix_map: [
            {
                name_suffix: 'शहरी नगर',
                children_levels: [
                    {
                        name_suffix: 'वस्ती',
                        level_id: 11
                    }
                ]
            }
        ]
    },

    {
        level_id: 8,
        level_suffix_map: [
            {
                name_suffix: 'उपखंड',
                children_levels: [
                    {
                        name_suffix: 'मंडल',
                        level_id: 9
                    }
                ]
            },
            {
                name_suffix: 'उपखंड नगर',
                children_levels: [
                    {
                        name_suffix: 'वस्ती',
                        level_id: 11
                    }
                ]
            }
        ]
    },

    {
        level_id: 9,
        level_suffix_map: [
            {
                name_suffix: 'मंडल',
                children_levels: [
                    {
                        name_suffix: 'गाव',
                        level_id: 10
                    }
                ]
            }
        ]
    }
];
const NodeActionDialog = React.memo(
    ({
        loadCurrentGeoTree,
        selectedYear,
        open,
        onClose,
        type, // "edit" or "delete" or "add"
        node, // the node object being acted upon,
        restrictedLevels
    }) => {
        const isEdit = type === 'edit';
        const isAdd = type === 'add';
        const isDelete = type === 'delete';

        const { confirm } = Modal;
        const { user, token } = useAuth();
        const dispatch = useDispatch();
        const [editableValue, setEditableValue] = useState({
            localizedName: '',
            name: ''
        });
        const [errorText, setErrorText] = useState({
            localizedName: '',
            name: '',
            childLevel: null
        });
        const [dialogContentButtonColor, setDialogContentButtonColor] = useState('');
        const [dialogTitle, setDialogTitle] = useState('');
        const [dialogContentButtonText, setDialogContentButtonText] = useState('');
        const [modalContent, setModalContent] = useState(null);
        const [toggleButtonValue, setToggleButtonValue] = useState(null);
        const [filteredChildLevels, setFilteredChildLevels] = useState([]);
        const [isLoading, setIsLoading] = useState(false);

        // close modal as well clear states value
        const closeModalState = () => {
            onClose();
            setEditableValue({
                localizedName: '',
                name: ''
            });
            setErrorText({ localizedName: '', name: '', childLevel: null });
            setToggleButtonValue(null);
            setFilteredChildLevels([]);
        };

        const onChangeGeoName = (e) => {
            const { name, value } = e.target ?? {};
            setEditableValue((prev) => ({
                ...prev,
                [name]: value
            }));
            setErrorText((prev) => ({
                ...prev,
                [name]: ''
            }));
        };

        // add new geo location service call function
        const addNewGeoLocation = () => {
            if (!toggleButtonValue) {
                setErrorText((prev) => ({ ...prev, childLevel: !toggleButtonValue ? 'कृपया स्तर निवडा!' : null }));
                return;
            }
            if (!editableValue.localizedName || !editableValue.name) {
                setErrorText({
                    localizedName: !editableValue.localizedName ? 'कृपया नाव मराठीत लिहा!' : '',
                    name: !editableValue.name ? 'कृपया नाव इंग्रजीत लिहा!' : ''
                });
                return;
            }

            setIsLoading(true);
            const selectedLevel = filteredChildLevels.find((i) => i?.name_suffix?.trim() === toggleButtonValue);

            const payload = {
                parentLocationId: node?.location_id ? Number(node?.location_id) : '',
                localized_name: editableValue.localizedName,
                name: editableValue?.name,
                level_id: selectedLevel?.level_id ? Number(selectedLevel?.level_id) : undefined,
                name_suffix: selectedLevel?.name_suffix,
                year: selectedYear
            };

            // Show the confirm modal
            confirm({
                title: 'हा नवीन भौगोलिक स्तर समाविष्ट करायचा आहे का?',
                icon: <WarningIcon fontSize="small" sx={{ color: 'yellow', mr: 2 }} />,
                // content: <pre>{formattedContent}</pre>, // Use <pre> to preserve newlines and spacing
                okText: 'होय',
                cancelText: 'नाही',
                width: '50%',
                centered: true,
                onOk() {
                    // console.log(payload, 'llooo');
                    addGeoLocationService(token, payload)
                        .then((response) => {
                            if (response?.newLocationId && Number(response?.newLocationId) > 0) {
                                closeModalState();
                                dispatch({
                                    type: SNACKBAR_OPEN,
                                    open: true,
                                    message: 'नवीन भौगोलिक स्तर यशस्वीरित्या जोडले गेले.',
                                    variant: 'alert',
                                    alertSeverity: 'success'
                                });
                                loadCurrentGeoTree(user.profile.location, selectedYear);
                            } else {
                                dispatch({
                                    type: SNACKBAR_OPEN,
                                    open: true,
                                    message: 'Something went wrong while adding new geo location',
                                    variant: 'alert',
                                    alertSeverity: 'error'
                                });
                            }
                            setIsLoading(false);
                        })
                        .catch((error) => {
                            closeModalState();
                            dispatch({
                                type: SNACKBAR_OPEN,
                                open: true,
                                message: 'Technical error. Please try again.',
                                variant: 'alert',
                                alertSeverity: 'error'
                            });
                            setIsLoading(false);
                        });
                },
                onCancel() {
                    console.log('No');

                    setIsLoading(false);
                },
                cancelButtonProps: {
                    danger: true // Change button color to red
                }
            });
        };

        // edit existing name service call function
        const saveGeoLocationName = () => {
            if (!editableValue.localizedName || !editableValue.name) {
                setErrorText({
                    localizedName: !editableValue.localizedName ? 'कृपया नाव मराठीत लिहा!' : '',
                    name: !editableValue.name ? 'कृपया नाव इंग्रजीत लिहा!' : ''
                });
                return;
            }
            if (!editableValue.localizedName || !editableValue.name) {
                setErrorText({
                    localizedName: 'कृपया नाव मराठीत लिहा!',
                    name: 'कृपया नाव इंग्रजीत लिहा!'
                });
                return;
            }

            setIsLoading(true);
            const payload = {
                locationId: node?.location_id ? Number(node?.location_id) : '',
                localized_name: editableValue.localizedName,
                name: editableValue?.name,
                year: selectedYear
            };

            // Show the confirm modal
            confirm({
                title: 'भौगोलिक स्थानाच्या नावात बदल करायचा आहे का?',
                icon: <WarningIcon fontSize="small" sx={{ color: 'yellow', mr: 2 }} />,
                // content: <pre>{formattedContent}</pre>, // Use <pre> to preserve newlines and spacing
                okText: 'होय',
                cancelText: 'नाही',
                width: '50%',
                centered: true,
                onOk() {
                    updateGeoLocationNameService(token, payload)
                        .then((response) => {
                            if (response?.updatedLocationId) {
                                closeModalState();
                                dispatch({
                                    type: SNACKBAR_OPEN,
                                    open: true,
                                    message: 'निवडलेले भौगोलिक स्थानाचे नाव यशस्वीरित्या बदलले',
                                    variant: 'alert',
                                    alertSeverity: 'success'
                                });
                                loadCurrentGeoTree(user.profile.location, selectedYear);
                            } else {
                                dispatch({
                                    type: SNACKBAR_OPEN,
                                    open: true,
                                    message: 'Something went wrong while updating location name',
                                    variant: 'alert',
                                    alertSeverity: 'error'
                                });
                            }
                            setIsLoading(false);
                        })
                        .catch((error) => {
                            closeModalState();
                            dispatch({
                                type: SNACKBAR_OPEN,
                                open: true,
                                message: 'Technical error. Please try again.',
                                variant: 'alert',
                                alertSeverity: 'error'
                            });
                            setIsLoading(false);
                        });
                },
                onCancel() {
                    console.log('No');

                    setIsLoading(false);
                },
                cancelButtonProps: {
                    danger: true // Change button color to red
                }
            });
        };

        // delete geo location service call function
        const deleteSelectedGeoLocation = () => {
            setIsLoading(true);
            const payload = {
                locationId: node?.location_id ? Number(node?.location_id) : '',
                year: selectedYear
            };
            deleteGeoLocationService(token, payload)
                .then((response) => {
                    if (response?.deletedLocationId && response?.deletedLocationId > 0) {
                        closeModalState();
                        dispatch({
                            type: SNACKBAR_OPEN,
                            open: true,
                            message: 'निवडलेले भौगोलिक स्तर यशस्वीरित्या हटवले',
                            variant: 'alert',
                            alertSeverity: 'success'
                        });
                        loadCurrentGeoTree(user.profile.location, selectedYear);
                    } else {
                        dispatch({
                            type: SNACKBAR_OPEN,
                            open: true,
                            message: 'Something went wrong while deleting geo location',
                            variant: 'alert',
                            alertSeverity: 'error'
                        });
                    }
                    setIsLoading(false);
                })
                .catch((error) => {
                    closeModalState();
                    dispatch({
                        type: SNACKBAR_OPEN,
                        open: true,
                        message: 'Technical error. Please try again.',
                        variant: 'alert',
                        alertSeverity: 'error'
                    });
                    setIsLoading(false);
                });
        };

        const handleToggleChange = (event, currChildLevel) => {
            setErrorText((prev) => ({
                ...prev,
                childLevel: null
            }));
            if (currChildLevel) {
                setToggleButtonValue(currChildLevel);
            }
        };

        useEffect(() => {
            let childLevels = [];

            LEVELS_DROPDOWN.forEach((i) => {
                if (i.level_id.toString().trim() === node?.level?.level_id?.trim()) {
                    const childLevelBasedOnParentSuffix = i?.level_suffix_map.find(
                        (j) => j.name_suffix.trim() === node?.name_suffix?.trim()
                    );
                    setFilteredChildLevels([...(childLevelBasedOnParentSuffix?.children_levels ?? [])]);
                    childLevels = [...(childLevelBasedOnParentSuffix?.children_levels ?? [])];
                }
            });

            // if in array only 1 element then show button toggle as pre selected with this element value
            if (childLevels.length === 1) {
                setToggleButtonValue(childLevels[0]?.name_suffix);
            }

            switch (type) {
                case 'edit':
                    setDialogContentButtonColor('primary');
                    setDialogContentButtonText('जतन करा');
                    setDialogTitle('भौगोलिक स्तराचे नाव बदला.');
                    setModalContent(
                        <Box sx={{ width: '100%', marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            {/* <Box
                                sx={{ width: '100%', display: 'flex', gap: '20px', justifyContent: 'flex-start', alignItems: 'flex-start' }}
                            >
                                <TextField
                                    sx={{
                                        width: '50%',
                                        '& .MuiInputBase-input.Mui-disabled': {
                                            color: '#000', // black text
                                            WebkitTextFillColor: '#000' // for certain browsers
                                        }
                                    }}
                                    label="नाव"
                                    variant="outlined"
                                    value={node?.localized_name ?? ''}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    disabled
                                />

                                <TextField
                                    sx={{
                                        width: '50%',
                                        '& .MuiInputBase-input.Mui-disabled': {
                                            color: '#000', // black text
                                            WebkitTextFillColor: '#000' // for certain browsers
                                        }
                                    }}
                                    label="स्तर"
                                    variant="outlined"
                                    value={node?.name_suffix ?? ''}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    disabled
                                />
                            </Box> */}

                            <Divider />

                            {/* marathi geolocation name */}
                            <Box
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '10px',
                                    justifyContent: 'flex-start',
                                    alignItems: 'flex-start'
                                }}
                            >
                                <InputLabel sx={{ color: 'text.primary', fontSize: '18px' }}>
                                    सध्याचे मराठी नाव :-{' '}
                                    <Chip sx={{ color: '#000', fontSize: '18px' }} size="medium" label={node?.localized_name ?? '-'} />
                                    {/* <span style={{ fontWeight: 800, color: 'blue' }}>{?? '-'}</span>{' '} */}
                                </InputLabel>
                                <TextField
                                    sx={{ width: '100%' }}
                                    label="नवीन मराठी नाव"
                                    name="localizedName"
                                    placeholder="कृपया भौगोलिक स्थानाचे नाव मराठीत लिहा."
                                    variant="outlined"
                                    value={editableValue.localizedName}
                                    onChange={onChangeGeoName}
                                    error={!!errorText.localizedName}
                                    helperText={errorText.localizedName}
                                />
                            </Box>

                            <Divider />

                            {/* english geolocation name */}
                            <Box
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '10px',
                                    justifyContent: 'flex-start',
                                    alignItems: 'flex-start'
                                }}
                            >
                                <InputLabel sx={{ color: 'text.primary', fontSize: '18px' }}>
                                    सध्याचे इंग्रजी नाव :-{' '}
                                    <Chip sx={{ color: '#000', fontSize: '18px' }} size="medium" label={node?.name ?? '-'} />
                                    {/* <span style={{ fontWeight: 800, color: 'blue' }}>{node?.name ?? '-'}</span>{' '} */}
                                </InputLabel>
                                <TextField
                                    sx={{ width: '100%' }}
                                    label="नवीन इंग्रजी नाव"
                                    name="name"
                                    placeholder="कृपया भौगोलिक स्थानाचे नाव इंग्रजीत लिहा."
                                    variant="outlined"
                                    value={editableValue.name}
                                    onChange={onChangeGeoName}
                                    error={!!errorText.name}
                                    helperText={errorText.name}
                                />
                            </Box>
                        </Box>
                    );
                    break;

                case 'add':
                    setDialogContentButtonColor('primary');
                    setDialogContentButtonText('जोडा');
                    setDialogTitle('नवीन भौगोलिक स्तर समाविष्ट करा.');
                    setModalContent(
                        <Box sx={{ width: '100%', marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            {/* parent details */}
                            <InputLabel sx={{ color: 'text.primary' }}>निवडलेल्या स्तराची माहिती</InputLabel>
                            <Box
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    gap: '20px',
                                    justifyContent: 'flex-start',
                                    alignItems: 'flex-start'
                                }}
                            >
                                <TextField
                                    sx={{
                                        width: '50%',
                                        '& .MuiInputBase-input.Mui-disabled': {
                                            color: '#000', // black text
                                            WebkitTextFillColor: '#000' // for certain browsers
                                        }
                                    }}
                                    label="नाव"
                                    variant="outlined"
                                    value={node?.localized_name ?? ''}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    disabled
                                />

                                <TextField
                                    sx={{
                                        width: '50%',
                                        '& .MuiInputBase-input.Mui-disabled': {
                                            color: '#000', // black text
                                            WebkitTextFillColor: '#000' // for certain browsers
                                        }
                                    }}
                                    label="स्तर"
                                    variant="outlined"
                                    value={node?.name_suffix ?? ''}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    disabled
                                />
                            </Box>

                            <Divider />

                            <Box sx={{ marginTop: '-10px', display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <InputLabel sx={{ color: errorText.childLevel ? 'error.main' : 'text.primary' }}>
                                    समाविष्ट करण्यासाठी भौगोलिक स्तर निवडा
                                    <span style={{ color: 'red', fontSize: 16 }}>*</span>
                                </InputLabel>

                                <ToggleButtonGroup
                                    color="success"
                                    value={toggleButtonValue}
                                    exclusive
                                    onChange={handleToggleChange}
                                    aria-label="स्तर निवडा"
                                >
                                    {childLevels.map((i) => (
                                        <ToggleButton
                                            sx={{ paddingInline: '20px', borderRadius: '10px' }}
                                            key={i?.name_suffix?.trim()}
                                            value={i?.name_suffix?.trim()}
                                        >
                                            {i?.name_suffix?.trim()}
                                        </ToggleButton>
                                    ))}
                                </ToggleButtonGroup>

                                {errorText.childLevel && (
                                    <Typography variant="caption" color="error">
                                        {errorText.childLevel}
                                    </Typography>
                                )}
                            </Box>

                            {/* english geolocation name */}
                            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <InputLabel sx={{ color: errorText.name ? 'error.main' : 'text.primary' }}>
                                    इंग्रजीत नाव
                                    <span style={{ color: 'red', fontSize: 16 }}>*</span>
                                </InputLabel>
                                <TextField
                                    disabled={!toggleButtonValue}
                                    sx={{ width: '100%' }}
                                    // label="इंग्रजीत नाव"
                                    name="name"
                                    placeholder="कृपया भौगोलिक स्थानाचे नाव इंग्रजीत लिहा."
                                    variant="outlined"
                                    value={editableValue.name}
                                    onChange={onChangeGeoName}
                                    error={!!errorText.name}
                                    helperText={errorText.name}
                                />
                            </Box>

                            {/* marathi geolocation name */}
                            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <InputLabel sx={{ color: errorText.localizedName ? 'error.main' : 'text.primary' }}>
                                    मराठीत नाव
                                    <span style={{ color: 'red', fontSize: 16 }}>*</span>
                                </InputLabel>
                                <TextField
                                    disabled={!toggleButtonValue}
                                    sx={{ width: '100%' }}
                                    // label="मराठीत नाव"
                                    name="localizedName"
                                    placeholder="कृपया भौगोलिक स्थानाचे नाव मराठीत लिहा."
                                    variant="outlined"
                                    value={editableValue.localizedName}
                                    onChange={onChangeGeoName}
                                    error={!!errorText.localizedName}
                                    helperText={errorText.localizedName}
                                />
                            </Box>
                        </Box>
                    );
                    break;

                case 'delete':
                    setDialogContentButtonColor('error');
                    setDialogContentButtonText('काढा');
                    setDialogTitle('निवडलेले भौगोलिक स्तर हटवण्याची पुष्टी करायची का?');
                    setModalContent(
                        <Box>
                            {!restrictedLevels.includes(node?.level?.level_id) && (
                                <Grid item xs={12} sx={{ marginBottom: '20px' }}>
                                    <Alert severity="warning" variant="filled" sx={{ color: '#000' }}>
                                        <AlertTitle sx={{ color: '#000' }}>
                                            चेतावणी: हे स्थान हटविल्यास या स्तराखालील सर्व भौगोलिक स्थाने कायमची हटविली जातील. कृपया
                                            काळजीपूर्वक पुढे जा.
                                        </AlertTitle>
                                    </Alert>
                                </Grid>
                            )}

                            <Typography variant="h3">
                                {node?.localized_name} - {node?.name_suffix}
                            </Typography>
                        </Box>
                    );
                    break;

                default:
                    break;
            }
        }, [editableValue, errorText, node, toggleButtonValue, type, restrictedLevels]);

        return (
            <Dialog open={open} onClose={closeModalState} fullWidth maxWidth="sm">
                {/* <DialogTitle>{isEdit ? 'सद्यरचना नाव बदला ' : 'Confirm Delete'}</DialogTitle> */}
                <DialogTitle>{dialogTitle}</DialogTitle>
                <DialogContent>{modalContent}</DialogContent>
                <DialogActions>
                    <Button disabled={isLoading} variant="contained" color="inherit" onClick={closeModalState}>
                        रद्द करा
                    </Button>
                    <Button
                        disabled={isLoading}
                        variant="contained"
                        color={dialogContentButtonColor}
                        onClick={() => {
                            if (isEdit) {
                                saveGeoLocationName();
                            } else if (isDelete) {
                                deleteSelectedGeoLocation();
                            } else {
                                addNewGeoLocation();
                            }
                        }}
                    >
                        {isLoading && <CircularProgress size={24} color="inherit" />}
                        {!isLoading && dialogContentButtonText}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
);

export default NodeActionDialog;
